import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { oneMatriculasAction } from '../MatriculasAction';
import { setActivoMatSeccionesAction } from './MatSeccionesAction';
import FormMatSecciones from './components/FormMatSecciones';
import ListadoMatSecciones from './components/ListadoMatSecciones';

const MatSeccionesView = () => {
  const dispatch = Redux.useDispatch();

  const matriculasStore = Redux.useSelector((state) => state.matriculas);
  const matSeccionesStore = Redux.useSelector((state) => state.matSecciones);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12} sx={{ display: 'flex', m: 1 }}>
        <BotonComponent
          click={async () => {
            await setActivoMatSeccionesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoMatSeccionesAction(dispatch, null);
            await oneMatriculasAction(dispatch, matriculasStore.activo.id);
          }}
          disabled={
            matriculasStore.loadingOne || matSeccionesStore.all.length === 0
          }
          white
          refreshIcon
          text={matriculasStore.loadingOne ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoMatSecciones
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormMatSecciones"
        title={`${
          matSeccionesStore.activo
            ? `Editar asignación de sección`
            : 'Nueva asignación de sección'
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormMatSecciones
          activo={matSeccionesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default MatSeccionesView;
